// extracted by mini-css-extract-plugin
export default {"wrapper":"o5-z","play":"p5-z"};